<template>
    <div class="wrapper" :class="['dashboard-wrapper', { 'lesson-mode': isLesson }]">
        <div class="elfsight-app-ca3ab46b-9560-4dc2-8a55-c155a14bc795" data-elfsight-app-lazy></div>
        <v-idle :wait="5" @remind="onremind" :reminders="[30]" :loop="true" :events="['mousemove']" @idle="onidle" :duration="logoutDuration"/>
        <notifications></notifications>
        <side-bar>
            <template slot="links">
                <div v-if="editor === 'super-admin' || editor === 'sub-admin'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewCompany))" :link="{ name: 'Companies', icon: 'menu-icons companiesicon', path: '/all_companies', }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="!isSafeDig && ((editor === 'super-admin') || ((editor === 'sub-admin') && (canViewCompany)))" :link="{ name: 'Companies Branding', icon: 'menu-icons companiesicon', path: '/admin/branding', }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewUser))" :link="{ name: 'Users', icon: 'menu-icons usersicon', path: '/all_users',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewCourse))" :link="{ name: 'Courses', icon: 'menu-icons coursesicon',}">
                        <sidebar-item :link="{ name: 'Courses', path: '/courses' }"/>
                        <sidebar-item :link="{ name: 'Course Folders', path: '/course_folder' }"/>
                        <sidebar-item :link="{ name: 'Create with AI', path: '/create_course?origin=sidebar', query: {origin: 'sidebar'} }"/>
                    </sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewResource))" :link="{ name: 'Resources', icon: 'menu-icons Resourcesicon', path: '/resources', }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewCertificate))" :link="{ name: 'Certificates', icon: 'menu-icons certificatesicon', path: '/certificates', }"></sidebar-item>
                    <!-- Reports start  -->
                    <sidebar-item class="mb-4" :link="{ name: 'Reports', icon: 'menu-icons Reportsicon',}">

                    <sidebar-item  :link="{ name: 'Test Question Report', icon: 'menu-icons question-icon', path: '/test_question_report',}"></sidebar-item>
                    <sidebar-item  :link="{ name: 'Survey Report', icon: 'menu-icons documents', path: '/survey_report', }"></sidebar-item>
                    <sidebar-item  :link="{ name: 'Login Report', icon: 'menu-icons info-icon',path: '/login_report',}"></sidebar-item>
                    <sidebar-item  :link="{ name: 'Activity Report', icon: 'menu-icons info-icon', path: '/activity_report'}"></sidebar-item>
                    <sidebar-item  :link="{name: 'Course Pass/Fail Report', icon: 'menu-icons course-status', path: '/course_fail_pass_report',}"></sidebar-item>
                    <sidebar-item  :link="{ name: 'SCORM Report', icon: 'menu-icons info-icon', path: '/scorm-report', }"></sidebar-item>
                    <sidebar-item  :link="{name: 'Documents Report', icon: 'menu-icons info-icon',path: '/documents-report'}"></sidebar-item>
                    <sidebar-item  :link="{ name: 'Onboarding Report', icon: 'menu-icons info-icon', path: '/all_onboarding_report'}"></sidebar-item>
                    <sidebar-item  :link="{name: 'Promo Code Reports',icon: 'menu-icons info-icon',path: '/promo_code_report',}"></sidebar-item>
                    <sidebar-item :link="{ name: 'Leads', icon: 'menu-icons info-icon', path: '/leads'}"></sidebar-item>
                    <sidebar-item :link="{ name: 'Abandon Carts', icon: 'menu-icons info-icon', path: '/abandon_carts'}"></sidebar-item>
                    <sidebar-item :link="{ name: 'User Activity Report', icon: 'menu-icons certificatesicon', path: '/user_activity_history',}"></sidebar-item>
                    </sidebar-item>
                    <!-- Reports end  -->
                    <!-- <sidebar-item v-if="(editor === 'super-admin') || ((editor === 'sub-admin'))" :link="{ name: 'Global Alerts', icon: 'menu-icons touricon', path: '/alerts_manager', }"></sidebar-item> -->

                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewTutorial))" :link="{name: 'Tutorial Videos', icon: 'menu-icons TutorialVideosicon', path: '/tutorial_video'}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewResource))" :link="{ name: 'Marketing', icon: 'menu-icons Marketingicon', path: '/marketing',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewResource))" :link="{ name: 'Email Templates', icon: 'menu-icons EmailTemplateicon', path: '/email_template',}"></sidebar-item>
                    <sidebar-item  class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewTutorial))" :link="{ name: 'Global Alerts', icon: 'menu-icons global-alerts-icon', path: '/alerts_manager', }"></sidebar-item>
                    <sidebar-item  class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewTutorial))" :link="{ name: 'User Agreement Popup', icon: 'menu-icons user-agreement-icon', path: '/user-agreement-manager', }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewTour))" :link="{name: 'Tour',icon: 'menu-icons TutorialVideosicon',path: '/tour_page',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="(editor === 'super-admin') || ((editor === 'sub-admin') && (canViewTour))" :link="{name: 'Notifications',icon: 'menu-icons notification-ico',path: '/all_notifications',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="!isSafeDig && ((editor === 'super-admin') || ((editor === 'sub-admin') && (canViewCourse)))" :link="{ name: 'Sign Up Pages', icon: 'menu-icons user-icon',}">
                        <sidebar-item :link="{ name: 'Concord Hospitality Group', path: '/concord-hospitality-group' }"/>
                    </sidebar-item>
                    <sidebar-item class="mb-4" v-if="editor!='sub-admin'" :link="{name: 'Sub Admin',icon: 'menu-icons user-icon',path: '/create_subadmin',}"></sidebar-item>
                    <sidebar-item
            v-if="!isSafeDig"
            class="mb-4"
            :link="{
              name: 'Addons',
              icon: 'menu-icons addson-icon',
              path: '/addons',
            }"
          ></sidebar-item>
                    <sidebar-item class="mb-4" :link="{name: 'Promo Codes',icon: 'menu-icons promo-code',path: '/promo_codes',}"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" :link="{name: 'My Profile',icon: 'menu-icons MyProfileicon',path: '/account',}"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none " @click.native="logoutUser" :link="{name: 'Logout', icon: 'menu-icons logout-icon',path: '/login'}"></sidebar-item>
                    <!-- <li class="nav-item  nav-profile mb-3" >
                        <router-link data-toggle="collapse" to="/account" class="sidebar-menu-item nav-link">
                                <span name="Reports" class="nav-link-text">My Profile <b class="caret"></b></span>
                        </router-link>
                    </li> -->

                </div>
                <div v-if="editor === 'company' || editor === 'manager'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{name: 'Dashboard',icon: 'dashbaordicon menu-icons',path: '/dashboard',}"></sidebar-item>
                    <!-- Project GLAD learner features — shown only on the CCU/GLAD-features build -->
                    <sidebar-item class="mb-4" v-if="gladFeaturesEnabled" :link="{ name: 'Pathways', icon: 'menu-icons coursesicon', path: '/glad/pathways' }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="gladFeaturesEnabled" :link="{ name: 'Badges', icon: 'menu-icons certificatesicon', path: '/glad/badges' }"></sidebar-item>
                    <sidebar-item class="mb-4" v-if="gladFeaturesEnabled" :link="{ name: 'Content Library', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" v-intro="'Click here to see a list of all employees in your account.'" v-intro-step="4" :link="{name: 'Employees',icon: 'menu-icons Employeesicon',path: '/company_employees',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-intro="'Click here to see a list of all locations in your account.'" v-intro-step="5" :link="{name: 'Locations',icon: 'menu-icons Locationsicon',path: '/company_locations',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-intro="'Click here to see the courses assigned to your company as well as the courses assigned to you in the My Courses link.'" v-intro-step="6" :link="{ name: 'Courses', icon: 'menu-icons coursesicon',}">
                        <sidebar-item :link="{ name: 'My Courses', path: '/employee_courses' }"/>
                        <sidebar-item :link="{ name: 'Course Catalog', path: '/company_courses' }"/>
                        <sidebar-item :link="{ name: 'Course Folders', path: '/company_coursefolders'}"/>
                        <sidebar-item v-if="editor === 'company'" :link="{ name: 'Company Courses', path: '/courses' }"/>
<!--                        <sidebar-item :link="{ name: 'Purchase Course', icon: 'menu-icons coursesicon', path: '/employee_course_purchase',}"/>-->

                    </sidebar-item>

<!--                    <sidebar-item v-intro="'Click here to see the courses assigned to your company as well as the courses assigned to you in the My Courses link.'" v-intro-step="6" :link="{name: 'Courses',icon: 'menu-icons coursesicon',}">
                        <sidebar-item :link="{ name: 'Company Courses', path: '/company_courses' }"/>
                        <sidebar-item :link="{name: 'Company Course Folders', path: '/company_coursefolders'}"/>
                        <sidebar-item :link="{ name: 'My Courses', path: '/employee_courses' }"/>
                        <sidebar-item :link="{ name: 'Purchase Course', icon: 'menu-icons coursesicon', path: '/employee_course_purchase',}"/>
                    </sidebar-item>-->
                    <sidebar-item class="mb-4" v-intro="'Click here to see employee certificates as well as any certificates you have earned.'" v-intro-step="7" :link="{ name: 'Certificates', icon: 'menu-icons certificatesicon',}">
                        <sidebar-item :link="{ name: 'Employee Certificates', path: '/company_certificates',}"/>
                        <sidebar-item :link="{name: 'My Certificates', path: '/employee_certificates', }"/>
                    </sidebar-item>
                    <!-- <sidebar-item class="mb-4"  :link="{ name: 'Resources', icon: 'menu-icons Resourcesicon', path: '/employee_resources', }">
                    </sidebar-item> -->
                    <sidebar-item class="mb-4"  :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/notification', }">
                    </sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: employeeDocumentsSidebarLabel, icon: 'menu-icons documents',path: '/employee_documents',}"></sidebar-item>
                    <sidebar-item class="hideActive mb-4" data-tour-step="7" v-intro="'Click here to download various reports for your company.'" v-intro-step="8" :link="{ name: 'Reports', icon: 'menu-icons Reportsicon',}">
                        <sidebar-item v-if="!progressButtonContent" :link="{name: 'Send Progress Report', path: $route.path + '#sending_progress_report',}" @click.native="generateProgress"/>
                        <sidebar-item v-else :link="{ name: 'Sending...', icon: 'ni ni-collection text-blue', path: $route.path + '#sending_progress_report', }"/>
                        <sidebar-item v-if="!userDownloadButtonContent" :link="{ name: 'User Report', path: $route.path + '#downloading_user_report', }" @click.native="downloadUserList"/>
                        <sidebar-item v-else :link="{ name: 'Downloading...', icon: 'ni ni-collection text-blue', path: $route.path + '#downloading_user_report', }"/>
                        <sidebar-item v-if="!courseDownloadButtonContent" :link="{name: 'Course Report', path: $route.path + '#downloading_course_report', }" @click.native="handleDownload"/>
                        <sidebar-item v-else :link="{ name: 'Downloading...', icon: 'ni ni-collection text-blue', path: $route.path + '#downloading_course_report', }"/>
                        <sidebar-item v-if="!certificateDownloadButtonContent" :link="{ name: 'Certificate Report', path: $route.path + '#downloading_certificate_report', }" @click.native="downloadCertificateList"/>
                        <sidebar-item v-else :link="{ name: 'Downloading...', icon: 'ni ni-collection text-blue', path: $route.path + '#downloading_certificate_report', }"/>
                        <sidebar-item :link="{ name: 'Login Report', icon: 'menu-icons certificatesicon',path: '/login_report',}"/>
                        <sidebar-item :link="{ name: 'Activity Report', icon: 'menu-icons certificatesicon', path: '/activity_report', }"/>
                        <sidebar-item :link="{ name: 'Course Pass/Fail Report', icon: 'menu-icons certificatesicon', path: '/course_fail_pass_report', }"/>
                        <sidebar-item :link="{name: 'Documents Report',path: '/documents-report'}"/>
                        <sidebar-item :link="{ name: 'SCORM Report', path: '/scorm-report', }"></sidebar-item>
                    </sidebar-item>

                    <sidebar-item class="mb-4" v-intro=" 'Here you will find helpful tutorial videos that will show you how to navigate through your account.' " v-intro-step="1" :link="{ name: 'Tutorial Videos', icon: 'menu-icons TutorialVideosicon', path: '/tutorial_video', }"></sidebar-item>

                    <sidebar-item class="mb-4 d-md-none" v-intro="'Click here to edit your profile information.'" v-intro-step="9" name="My Profile" :link="{ name: 'My Profile', icon: 'menu-icons MyProfileicon', path: '/account', }">
                    </sidebar-item>
                    <sidebar-item class="mb-4 d-md-none " @click.native="logoutUser" :link="{name: 'Logout', icon: 'menu-icons logout-icon',path: '/login'}"></sidebar-item>
                    <!-- <li class="nav-item  nav-profile mb-3" >
                        <router-link data-toggle="collapse" to="/account" class="sidebar-menu-item nav-link">
                                <span name="Reports" class="nav-link-text">My Profile <b class="caret"></b></span>
                        </router-link>
                    </li> -->

                </div>
                <div v-if="editor === 'employee'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard', }"></sidebar-item>
                    <sidebar-item class="mb-4" v-intro="'Here you will find all of your courses, Open, Overdue, Failed, and Passed.'" v-intro-step="4" :link="{ name: 'Courses', icon: 'menu-icons coursesicon', path: '/employee_courses', }"></sidebar-item>
<!--                    <sidebar-item :link="{ name: 'Purchase Course', icon: 'menu-icons coursesicon', path: '/employee_course_purchase', }"/>-->
                    <sidebar-item class="mb-4" v-intro="'Here you will find all of your certificates.'" v-intro-step="3" :link="{ name: 'Certificates', icon: 'menu-icons certificatesicon', path: '/employee_certificates',}"></sidebar-item>
                    <!-- <sidebar-item class="mb-4" :link="{name: 'Resources',icon: 'menu-icons Resourcesicon',path: '/employee_resources',}"></sidebar-item> -->
                    <sidebar-item class="mb-4"  :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/notification', }">
                    </sidebar-item>
                    <sidebar-item class="mb-4" :link="{name: employeeDocumentsSidebarLabel,icon: 'menu-icons documents',path: '/employee_documents',}"></sidebar-item>
                    <sidebar-item class="mb-4" v-intro=" 'Here you will find helpful tutorial videos that will show you how to navigate through your account.'" v-intro-step="2" :link="{name: 'Tutorial Video', icon: 'menu-icons TutorialVideosicon', path: '/tutorial_video',}"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none " @click.native="logoutUser" :link="{name: 'Logout', icon: 'menu-icons logout-icon',path: '/login'}"></sidebar-item>

                    <sidebar-item class="mb-4 d-md-none" name="My Profile" :link="{ name: 'My Profile ', icon: 'menu-icons MyProfileicon', path: '/add_employee', }"></sidebar-item>
                    <!-- <li class="nav-item  nav-profile mb-3" >
                        <router-link data-toggle="collapse" to="/add_employee" class="sidebar-menu-item nav-link">
                                <span name="Reports" class="nav-link-text">My Profile <b class="caret"></b></span>
                        </router-link>
                    </li> -->
                </div>

                <!-- Project GLAD: Educator -->
                <div v-if="editor === 'glad_educator'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Pathways', icon: 'menu-icons coursesicon', path: '/glad/pathways' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Badges', icon: 'menu-icons certificatesicon', path: '/glad/badges' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Certificates', icon: 'menu-icons certificatesicon', path: '/employee_certificates' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Content Library', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Resources', icon: 'menu-icons Resourcesicon', path: '/employee_resources' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/notification' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" :link="{ name: 'My Profile', icon: 'menu-icons MyProfileicon', path: '/add_employee' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" @click.native="logoutUser" :link="{ name: 'Sign out', icon: 'menu-icons logout-icon', path: '/login' }"></sidebar-item>
                </div>

                <!-- Project GLAD: Trainer -->
                <div v-if="editor === 'glad_trainer'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Pathways', icon: 'menu-icons coursesicon', path: '/glad/pathways' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Trainer Resources', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Badges', icon: 'menu-icons certificatesicon', path: '/glad/badges' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Certificates', icon: 'menu-icons certificatesicon', path: '/employee_certificates' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Content Library', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'RTC Roster', icon: 'menu-icons Employeesicon', path: '/glad/rtc-members' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/notification' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" :link="{ name: 'My Profile', icon: 'menu-icons MyProfileicon', path: '/add_employee' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" @click.native="logoutUser" :link="{ name: 'Sign out', icon: 'menu-icons logout-icon', path: '/login' }"></sidebar-item>
                </div>

                <!-- Project GLAD: RTC Admin -->
                <div v-if="editor === 'glad_rtc_admin'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Users', icon: 'menu-icons usersicon', path: '/glad/users' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'RTC Members', icon: 'menu-icons Employeesicon', path: '/glad/rtc-members' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Pathways', icon: 'menu-icons coursesicon', path: '/glad/pathways' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Courses', icon: 'menu-icons coursesicon', path: '/glad/courses' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Content Library', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'RTC Analytics', icon: 'menu-icons Reportsicon', path: '/glad/analytics' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'My Badges', icon: 'menu-icons certificatesicon', path: '/glad/badges' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Certificates', icon: 'menu-icons certificatesicon', path: '/company_certificates' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" @click.native="logoutUser" :link="{ name: 'Sign out', icon: 'menu-icons logout-icon', path: '/login' }"></sidebar-item>
                </div>

                <!-- Project GLAD: NTC Admin -->
                <div v-if="editor === 'glad_ntc_admin'">
                    <sidebar-item class="mb-4" v-if="!isGlad" :link="{ name: 'Dashboard', icon: 'dashbaordicon menu-icons', path: '/dashboard' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'All RTCs', icon: 'menu-icons companiesicon', path: '/glad/rtcs' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Pathways', icon: 'menu-icons coursesicon', path: '/glad/pathways' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Courses', icon: 'menu-icons coursesicon', path: '/glad/courses' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'AI Course Builder', icon: 'menu-icons coursesicon', path: '/glad/ai/course-builder' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Content', icon: 'menu-icons Resourcesicon', path: '/glad/content' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Badges', icon: 'menu-icons certificatesicon', path: '/glad/badges' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'National Analytics', icon: 'menu-icons Reportsicon', path: '/glad/analytics' }"></sidebar-item>
                    <sidebar-item class="mb-4" :link="{ name: 'Users', icon: 'menu-icons usersicon', path: '/glad/users' }"></sidebar-item>
                    <sidebar-item class="mb-4 d-md-none" @click.native="logoutUser" :link="{ name: 'Sign out', icon: 'menu-icons logout-icon', path: '/login' }"></sidebar-item>
                </div>
            </template>
        </side-bar>
        <div class="main-content px-4">
          <billing-banner />
          <template>
          <div v-if="alert.isActive && alert.show_options === 'dashboard'"
              :class="`custom-alert-style alert alert-${alert.color} alert-dismissible fade show d-flex justify-content-between align-items-center`"
              role="alert">

            <div v-html="alert.message"></div>

            <!-- ✅ Refresh Button Visible Only If refresh == true -->
            <button
              v-if="alert.refresh"
              class="btn btn-sm btn-dark ml-3"
              @click="refreshPage"
              title="Refresh">
              🔄 Refresh
            </button>
          </div>
        </template>

            <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
            <div @click="$sidebar.displaySidebar(false)">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <router-view></router-view>
                </fade-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
        <modal :show.sync="downlaodModel">
            <h3 slot="header" style="color: #444c57" class="title title-up">Download Course Report</h3>
            <div class="select-style">
            <el-select v-model="filters.course_id" filterable placeholder="All Courses" class="w-100">
                <el-option class="select-default" v-for="item in companyCourses" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            </div>
            <form>
                <br/>
                <div class="row d-flex justify-content-center align-items-center">
                    <base-button outline="true" type="primary" @click.prevent="downloadcourselist('all')">All</base-button>
                    <base-button outline="true" type="primary" @click.prevent="downloadcourselist('open')">{{ isSafeDig ? 'Assigned' : 'Open Courses' }}</base-button>
                    <base-button outline="true" type="primary" @click.prevent="downloadcourselist('non-complaint')">{{ isSafeDig ? 'Overdue' : 'Non Compliance' }}</base-button>
                    <base-button outline="true" type="primary" @click.prevent="downloadcourselist('complaint')">{{ isSafeDig ? 'Passed' : 'Compliance' }}</base-button>
                </div>
                <div class="clearfix"></div>
            </form>
        </modal>
        <modal :show.sync="documentSignModel" v-on:close="onclosedocumentSignModel" size="xl">
            <h4 slot="header" style="color: #444c57" class="modal-title mb-0">
                User Onboarding
            </h4>
            <user-onboarding/>
        </modal>
        <modal :show.sync="showEmployeePostLoginSurvey" size="xl">
            <h4 slot="header" style="color: #444c57" class="modal-title mb-0">
                Post Login Survey
            </h4>
            <post-login-survey-employee v-if="showEmployeePostLoginSurvey" v-on:hideEmployeeSurveyPopup="hideEmployeeSurveyPopup"/>
        </modal>

        <!-- GLAD AI assistant — floats over every authenticated GLAD page -->
        <ai-support-chat v-if="isGlad" />
    </div>
</template>
<script>
/* eslint-disable no-new */
import Vue from "vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import UserOnboarding from "@/views/Super/UserOnboarding.vue";
import PostLoginSurveyEmployee from "@/views/Super/PostLoginSurveyEmployee.vue";
import AiSupportChat from "@/components/glad/AiSupportChat.vue";
import {Option, Select} from "element-ui";
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import BillingBanner from "@/views/Components/BillingBanner.vue";
import {FadeTransition} from "vue2-transitions";
import XLSX from "xlsx";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import introJs from "intro.js";
import Vidle from "v-idle";
import { bus } from '@/bus.js';

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}


Vue.use(Vidle);
export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        DashboardNavbar,
        ContentFooter,
        FadeTransition,
        UserOnboarding,
        PostLoginSurveyEmployee,
        BillingBanner,
        AiSupportChat,
    },
    data() {
        return {
            _alertPoll: null,
             alert: {
                isActive: false,
                message: '',
                color: 'success',
                refresh: false,
                show_options: '',

            },
            trackUserActivityInterval:"",
            progressButtonContent: false,
            userDownloadButtonContent: false,
            certificateDownloadButtonContent: false,
            courseDownloadButtonContent: false,
            companyCourses: [],
            downlaodModel: false,
            hot_user: "",
            hot_token: "",
            editor: "",
            filters: {
                course_id: "All Courses",
            },
            steps: "",
            company_onboarding_status: false,
            documentSignModel: false,
            logoutDuration: 1800,
            canCreate: true,
            canEdit: true,
            canDelete: true,
            canViewCompany: false,
            canViewUser: false,
            canViewCourse: false,
            canViewCertificate: false,
            canViewResource: false,
            canViewTutorial: false,
            canViewTour: false,
            showEmployeePostLoginSurvey: false,
            isVideoPlaying: false,
        };
    },
    created: function () {
        if (localStorage.getItem("hot-token")) {
            this.hot_user = localStorage.getItem("hot-user");
            this.hot_token = localStorage.getItem("hot-token");
        } else {
            this.$router.push("/login");
        }

        const hotUser = localStorage.getItem("hot-user");
        const gladRoles = ['glad_educator', 'glad_trainer', 'glad_rtc_admin', 'glad_ntc_admin'];
        if (gladRoles.includes(hotUser)) {
            this.editor = hotUser;
        } else if (hotUser === "employee") {
            this.editor = "employee";
        } else if (hotUser === "super-admin") {
            this.editor = "super-admin";
        } else if (hotUser === "sub-admin") {
            this.editor = "sub-admin";
            this.getRightsDetails();
        } else if (hotUser === "company-admin") {
            this.editor = "company";
        }
        if (localStorage.getItem("hot-sidebar") === "manager") {
            this.editor = "manager";
        }

      // Hide reCAPTCHA badge instantly
      const style = document.createElement('style');
      style.innerHTML = '.grecaptcha-badge { visibility: hidden !important; }';
      document.head.appendChild(style);
    },

    methods: {
      refreshPage() {
    window.location.reload(); // OR this.$router.go(0);
  },
         fetchAlert() {
            this.$http
            .get('alert/get')    // <-- make sure this exactly matches your Network tab!
            .then(({ data }) => {
                console.log('⏱️  fetched alert:', data)
                // apply into the existing reactive object
                this.alert.message  = data.message
                this.alert.color    = data.color
                this.alert.isActive = data.isActive === true || data.isActive === 1
                this.alert.refresh  = data.refresh === true || data.refresh === 1
                this.alert.show_options = data.show_options
            })
            .catch(err => {
                console.warn('Failed to fetch alert', err)
            })
        },
      async logoutUser() {
           await this.$http.get("user/logout_time").then((resp) => {
                localStorage.removeItem("hot-token");
                localStorage.removeItem("hot-email");
                localStorage.removeItem("hot_payment_responsible");
                localStorage.removeItem("hot-sidebar");
                localStorage.removeItem("hot-user-id");
                localStorage.removeItem("hot-company-id");
                localStorage.removeItem("hot-user");
                localStorage.removeItem("hot-glad-role");
                localStorage.removeItem("all_user_search_data");
                localStorage.removeItem("all_company_search_data");
                localStorage.removeItem("all_courses_search_data");
                localStorage.removeItem("all_certificate_search_data");
                localStorage.removeItem("all_tutorial_video_search_data");
                localStorage.removeItem("all_certificate_detail_search_data");
                localStorage.removeItem("hospitality-insurance");
                delete this.$http.defaults.headers["authorization"];


                const isSafeDig = process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
                const redirectKey = localStorage.getItem('other-company-login');
                localStorage.removeItem("other-company-login");
                if (isSafeDig) {
                  this.$router.push('/login');
                } else if (redirectKey) {
                    this.$router.push(`/${redirectKey}`);
                } else {
                    this.$router.push('/login');
                }
            });
         Swal.close();

        },
        getRightsDetails() {
            let type = "All";
            this.$http.get("subadmin/subadmin_rights/" + type).then(resp => {
                this.canViewCompany = resp.data[0].permissions.indexOf('v') !== -1;
                this.canViewUser = resp.data[1].permissions.indexOf('v') !== -1;
                this.canViewCourse = resp.data[2].permissions.indexOf('v') !== -1;
                this.canViewCertificate = resp.data[3].permissions.indexOf('v') !== -1;
                this.canViewResource = resp.data[4].permissions.indexOf('v') !== -1;
                this.canViewTutorial = resp.data[5].permissions.indexOf('v') !== -1;
                this.canViewTour = resp.data[6].permissions.indexOf('v') !== -1;
            });
        },
        onidle() {
          if (this.isVideoPlaying) {
            console.log('Idle event ignored because video is playing.');
            // Optionally, reset the idle timer if your v-idle component supports that.
            return;
          }
            // this.onclosedocumentSignModel();
            let time = 10;
            const timertest = this.set(time);
            Swal.fire({
          html: `Your session will automatically time out in
        <span id="time" style="color:red;font-weight:bold">${
              timertest != undefined ? timertest : time
          }</span>
        seconds due to inactivity.`,
          icon: "warning",
          confirmButtonClass: "btn",
          cancelButtonClass: "btn greybtn",
          confirmButtonColor: "#E0E0E0",
          cancelButtonColor: "",
          confirmButtonText: "Ok",
          showCancelButton: true,
          cancelButtonText: "<span style='color:black'>Keep me Logged In</span>",
            }).then((result) => {
          if (result.value) {
              this.logoutUser();
          } else {
              this.$router.go(this.$route.path);
          }
            });

        },
        onremind(time) {

        },
          set(time) {
          let timer = time - 1;
          const intervalId = setInterval(() => {
            let seconds = parseInt(timer % 60, 10);
            seconds = seconds < 10 ? "0" + seconds : seconds;

            const timeEl = document.querySelector("#time");
            if (timeEl) {
              timeEl.textContent = seconds;
            }

            if (--timer < 0) {
              clearInterval(intervalId); // ✅ clear it properly
              this.logoutUser();         // ✅ logout
            }
          }, 1000);
        },

        hideEmployeeSurveyPopup() {
            this.showEmployeePostLoginSurvey = false;
        },
        /** Set localStorage hot-replay-intro=1 or open any dashboard URL with ?replayIntro=1 — remove when no longer needed for QA. */
        shouldReplayIntroTour() {
            if (this.$route.query.replayIntro === "1") {
                return true;
            }
            return localStorage.getItem("hot-replay-intro") === "1";
        },
        initScrollbar() {
            let isWindows = navigator.platform.startsWith("Win");
            if (isWindows) {
                initScrollbar("sidenav");
            }
        },
        generateProgress() {
            this.progressButtonContent = true;
            this.$http.get("progress/generate_report").then((resp) => {
                this.progressButtonContent = false;
                if ((resp.data.length > 0) && resp.data.includes(null)) {
                    this.notifyVue("success", resp.data);
                } else if ((resp.data.length > 0) && !resp.data.includes(null)) {
                    this.notifyVue("danger", resp.data[0]);
                } else if (resp.data.length == 0) {
                    this.notifyVue("danger", 'No Admins/Mangers active for progress report.');
                } else {
                    this.notifyVue("danger", '');
                }
                this.$router.push(this.$route.path);
            });
        },
        downloadUserList() {
            this.userDownloadButtonContent = true;
            this.report_type = "all_user";
            this.$http
                .post("company/users", {
                    report_type: this.report_type,
                })
                .then((resp) => {
                    this.userDownloadButtonContent = false;
                    this.items = resp.data;
                    const data = XLSX.utils.json_to_sheet(this.items);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, data, "data");
                    XLSX.writeFile(wb, this.report_type + ".xlsx");

                    this.$router.push(this.$route.path);
                });
        },
        downloadCertificateList() {
            this.certificateDownloadButtonContent = true;
            this.$http
                .post("course/pass_employee", {
                    "search":"",
                    "certificate_status":"Active Certificates",
                    "download":1,
                    // certificate_status: "Active Certificates",
                    // user_type: "1"
                })
                .then((resp) => {
                    this.certificateDownloadButtonContent = false;
                    let employee_data = resp.data.employee;
                    for (let data of employee_data) {
                        let obj = [];
                        obj = {
                            course_name: data.course_name,
                        };
                    }
                    //this.course_name = this.course_name;
                    this.items = resp.data.download;
                    const data1 = XLSX.utils.json_to_sheet(this.items);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, data1, "data");
                    XLSX.writeFile(wb, "Certificate.xlsx");
                })
                .finally(() => (this.loading = false));
        },
        handleDownload() {
            this.$http.get("company/all_courses/" + 0).then((resp) => {
                this.companyCourses = [];
                let fobj = {
                    label: "All Courses",
                    value: "All Courses",
                };
                this.companyCourses.push(fobj);
                for (let data of resp.data[0].courses) {
                    let obj = {
                        label: data.name,
                        value: data.course_id,
                    };
                    this.companyCourses.push(obj);
                }
            });
            this.downlaodModel = true;
        },
        downloadcourselist(type) {
            this.loading = true;
            let report_type = "";
            if (type == "open") {
                this.report_type = "open_course";
            }
            if (type == "non-complaint") {
                this.report_type = "non_compliance";
            }
            if (type == "complaint") {
                this.report_type = "compliance";
            }
            if (type == "all") {
                this.report_type = "all";
            }
            this.$http
                .post("course/certificates/report", {
                    report_type: this.report_type,
                    company_id: this.company_id,
                    course_id: this.filters.course_id,
                })
                .then((resp) => {
                    this.items = resp.data;
                    const data = XLSX.utils.json_to_sheet(this.items);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, data, "data");
                    XLSX.writeFile(wb, this.report_type + ".xlsx");
                })
                .catch(function (error) {
                    self.processing = false;
                    if (error.response.status === 422) {
                        let respmessage = error.response.data.message;
                        Swal.fire({
                            title: "Error!",
                            text: respmessage,
                            icon: "error",
                        });
                    }
                })
                .finally(() => (this.loading = false));
        },
        notifyVue(type, data) {
            if (type == "success") {
                this.$notify({
                    message: "Progress Report Generated Successfully.",
                    timeout: 3000,
                    icon: "ni ni-bell-55",
                    type,
                });
            } else {
                this.$notify({
                    message: "Progress Report Not Generated. " + data,
                    timeout: 3000,
                    icon: "ni ni-bell-55",
                    type,
                });
            }
        },
        onclosedocumentSignModel() {
            Swal.fire({
                title: "Warning!",
                html: `Your company requires you to review and sign this section.  If you do not complete the section, you will be logged off of the system and unable to proceed with training.`,
                icon: "warning",
                showCancelButton: true,
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
                cancelButtonText: "Cancel",
                confirmButtonText: "Ok",
            }).then(result => {
                if (result.value) {
                    this.logoutUser();
                } else {
                    this.documentSignModel = true;
                }
            });
        },
        trackUserActivity() {
    this.$http.post("update_activity", {
        user_id: this.hot_user === 'company-admin'
            ? localStorage.getItem("hot-admin-id")
            : localStorage.getItem("hot-user-id"),
    })
    .then(() => {
        console.log("User activity updated");
    })
    .catch((err) => {
        console.error("Error updating user activity", err);

        // If API returns unauthorized (401), clear storage and redirect to login
        if (err.response && err.response.status === 401) {
            this.handleUnauthorized();
        }
    });
},

handleUnauthorized() {
    localStorage.removeItem("hot-token");
    localStorage.removeItem("hot_payment_responsible");
    localStorage.removeItem("hot-sidebar");
    localStorage.removeItem("hot-user-id");
    localStorage.removeItem("hot-company-id");
    localStorage.removeItem("hot-user");
    localStorage.removeItem("all_user_search_data");
    localStorage.removeItem("all_company_search_data");
    localStorage.removeItem("all_courses_search_data");
    localStorage.removeItem("all_certificate_search_data");
    localStorage.removeItem("all_tutorial_video_search_data");
    localStorage.removeItem("all_certificate_detail_search_data");

    delete this.$http.defaults.headers["authorization"];

    this.$router.push("/login");
}

    },
    mounted() {
       this.fetchAlert();

        // …then every 10 seconds
        this._alertPoll = setInterval(this.fetchAlert, 40_000);
      bus.$on('video-playing', (playing) => {
            this.isVideoPlaying = playing;
      });


        if (this.editor !== "super-admin" && this.editor !== "sub-admin") {
            document.addEventListener("mouseup", (e) => {
                if (e.target.attributes.name) {
                    let data = {
                        event: "Clicked on " + e.target.attributes.name.nodeValue,
                    };
                    this.$http
                        .post("user/add_activity", data)
                        .then((resp) => {
                        })
                        .catch(function () {
                        })
                        .finally(() => (this.loading = false));
                }
            });
            this.$http.get("user/login_check").then((resp) => {
                if (resp.data[0].company_onboarding_status) {
                    this.documentSignModel = true;
                }
                if (resp.data[0].is_first_login === 1) {
                    introJs().start();
                    this.$http.get("user/update_first_login_status").then((resp) => {
                        console.log("Done");
                    });
                } else if (this.shouldReplayIntroTour()) {
                    // Temporary: replay onboarding intro without resetting first-login flag.
                    localStorage.removeItem("hot-replay-intro");
                    this.$nextTick(() => {
                        setTimeout(() => introJs().start(), 500);
                    });
                    if (this.$route.query.replayIntro === "1") {
                        const q = { ...this.$route.query };
                        delete q.replayIntro;
                        this.$router.replace({ path: this.$route.path, query: q });
                    }
                }
                if (resp.data[0].company_survey_status.length > 0) {
                    this.showEmployeePostLoginSurvey = true;
                }

            });
        }

        this.initScrollbar();

        if (localStorage.getItem("hot-token")) {
        this.hot_user = localStorage.getItem("hot-user");
        this.hot_token = localStorage.getItem("hot-token");

        // Start tracking user activity every minute
        this.trackUserActivity();
        this.trackUserActivityInterval =  setInterval(() => {
            this.trackUserActivity();
        }, 60000); // 1 minute interval
    } else {
        this.$router.push("/login");
    }
    if (!window.hj) {
        (function (c, s, q, u, a, r, e) {
        c.hj=c.hj||function(){(c.hj.q=c.hj.q||[]).push(arguments)};
        c._hjSettings = { hjid: a };
        r = s.getElementsByTagName('head')[0];
        e = s.createElement('script');
        e.async = true;
        e.src = q + c._hjSettings.hjid + u;
        r.appendChild(e);
    })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', 6406698);
    }
    },
    computed: {

        isLesson() {
        return this.$route.name === 'LessonFormNew'; // or use path check: this.$route.path.includes('/lesson')
        },
        isSafeDig() {
            return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
        },
        isGlad() {
            return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'projectglad';
        },
        gladFeaturesEnabled() {
            return process.env.VUE_APP_ENABLE_GLAD_FEATURES === 'true'
                || process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'projectglad';
        },
        employeeDocumentsSidebarLabel() {
            return this.isSafeDig ? 'Resources' : 'Documents';
        },
    },
    beforeDestroy() {
    clearInterval(this._alertPoll);
    clearInterval(this.trackUserActivityInterval);
    bus.$off('video-playing');
  },
};
</script>

<style scoped>
.v-idle {
    text-align: center;
    display: none;
}
@media only screen and (max-width: 1024px) {

.lesson-mode ::v-deep(.main-content) {
  padding: 0 !important;
}
.lesson-mode ::v-deep(.hidenav) {
  display:none;
}
.lesson-mode ::v-deep(.sidenav) {
  display:none;
}
.lesson-mode ::v-deep(.footer.px-4.mx-2) {
  display:none;
}
.lesson-mode ::v-deep(.mobile-lesson) {
    min-height: 100vh;
        background-attachment: fixed;
        background-size: cover;
}
}


</style>
